

export const shuttlePrice = ( departure, destination ) => {
    if (departure === '' || destination === ''){
        return 0;
    } else if (departure === destination) {
        return 0;
    } else if (departure === 'ATO'){
        if (destination === 'Antigua'){
            return 25;
        } else {
            return -1;
        }
    } else if (departure === 'Antigua'){
        if (destination === 'ATO'){
            return 25;
        }  else if (destination === 'Pana'){
            return 35;
        } else if (destination === 'San Pedro'){
            return 35;
        } else if (destination === 'El Paredon'){
            return 30;
        } else if (destination === 'Xela'){
            return 45;
        } else if (destination === 'Chichi'){
            return 30;
        }
    }
};